module.exports = __webpack_public_path__ + "img/kommune-501.d20285ed.svg";